<template>
  <div class="notifier-position">
    <transition-group name="list" style="display: flex; flex-direction: column-reverse">
      <v-alert
          v-for="(mes, i) in notiList"
          :key="i"
          outlined
          min-height="56px"
          max-height="56px"
          min-width="360px"
          class="noti-card"
          :class="[ 'noti-' + mes.type ]"
          :type="mes.type"
          :value="!!mes.type && !!mes.text"
          :icon="icon"
          @click="clearNoti(mes.id)"
      >
        <div class="flex-center-col fill-height txt-detail">{{ $t(mes.text) }}</div>
      </v-alert>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { eventBus } from "../plugins/global-funcs"

export default {
  name: "Notifier",
  props: {
  },
  data () {
    return {
      icon: 'info'
    }
  },
  computed: {
    ...mapState({
      notiList: state => state.General.noti
    })
  },
  methods: {
    clearNoti (id) {
      eventBus.$emit('clearNotiTimeout', id)
    }
  }
}
</script>

<style scoped lang="scss">
.notifier-position {
  position: fixed;
  top: 32px;
  right: 32px;
  z-index: 99;
  height: 360px;
  pointer-events: none;
}
.noti-card {
  border-radius: 16px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  border: solid 2px !important;
  pointer-events: visible;
  cursor: pointer;
  &.noti-success {
    background: linear-gradient(180deg, #FFFFFF 0%, #EBFFFA 100%) !important;
  }
  &.noti-error {
    background: linear-gradient(180deg, #FFFFFF 0%, #FFF4F4 100%) !important;
  }
}
</style>
